import type { CanvasEx } from '@/typings/canvas';
import { DatadogEvent, fireDatadogLog } from '@/utils/datadogUtils';
import { getExtension, IMAGE_FILE_EXTENSIONS, VECTOR_FILE_EXTENSIONS } from '@/utils/pathUtils';

const CUSTOMILY_CLIPBOARD_KEY = 'customily-element';

export class FabricClipboard {
    constructor(public canvas: CanvasEx) {
        this.onPasteHandler = this.onPasteHandler.bind(this);
    }

    init() {
        document.addEventListener('paste', this.onPasteHandler);
    }

    static get customilyClipboardKey() {
        return CUSTOMILY_CLIPBOARD_KEY;
    }

    async registerCustomilyElement() {
        await navigator.clipboard.writeText(CUSTOMILY_CLIPBOARD_KEY);
    }

    async onPasteHandler(event: ClipboardEvent) {
        const container = event.target as HTMLDivElement;
        if (!event.clipboardData || container?.id != this.canvas.eventContainer) return;

        const items = event.clipboardData.items;
        const files = {
            images: [] as File[],
            vectors: [] as File[]
        };
        for (const item of items) {
            if (item.kind !== 'file') {
                files.vectors = [];
                files.images = [];
                break;
            }
            const file = item.getAsFile();
            if (!file) continue;

            const extension = `.${getExtension(file.name)}`;
            if (VECTOR_FILE_EXTENSIONS.has(extension)) {
                files.vectors.push(file);
            } else if (IMAGE_FILE_EXTENSIONS.has(extension)) {
                files.images.push(file);
            }
        }

        if (!files.images.length && !files.vectors.length) {
            await this.canvas.pasteCopiedObjects();
            return;
        }

        this.canvas.fire('files:pasted', files);

        fireDatadogLog(DatadogEvent.ClipboardPaste);
    }

    destroy() {
        document.removeEventListener('paste', this.onPasteHandler);
    }
}
